import { PropsWithChildren } from "react";

type PropsType = {
    className?: string;
    autoComplete?: string;
};

function Form({ children, className, autoComplete }: PropsWithChildren<PropsType>) {
    return (
        <form
            className={className}
            autoComplete={autoComplete}
            onSubmit={(e: React.SyntheticEvent) => {
                e.preventDefault();
            }}
        >
            {children}
        </form>
    );
}

export default Form;
